import { Injectable } from '@angular/core';
import { AppContext, BindingData, FrameContext } from '@farris/devkit';

/**
 * å®ä½æå¡
 * @scope FrameComponent
 */
@Injectable()
class BindingDataService {

  /**
   * æé å½æ°
   */
  constructor(
    private bindingData: BindingData,
    private appContext: AppContext
  ) { }

  /**
   * è®¾ç½®å½åæ¡æ¶çå½åè¡
   */
  setCurrentId(id: string, frameId: string) {
    // let bindingData = this.bindingData;
    // if (frameId) {
    //   const targetContext = this.appContext.getFrameContext(frameId);
    //   bindingData = targetContext.bindingData;
    // }
    // bindingData.list.setCurrentId(id);

    // @todoï¼å¨é¨éæ°è®¾ç½®ä¸é
    const frameContexts = Array.from(this.appContext.getAllFrameContexts().values());
    frameContexts.forEach((frameContext: FrameContext) => {
      const bindingData = frameContext.bindingData;
      bindingData.list.setCurrentId(id, true, false);
    });
  }
  public setCurrentRow(id: string, frameId: string) {
    let bindingData = this.bindingData;
    if (frameId) {
      const targetContext = this.appContext.getFrameContext(frameId);
      bindingData = targetContext.bindingData;
    }
    bindingData.getList().setCurrentId(id);
  }
}

export { BindingDataService };
